"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require("react-autosuggest");

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _lodash = require("lodash");

var _LoadingIcon = require("./LoadingIcon");

var _LoadingIcon2 = _interopRequireDefault(_LoadingIcon);

require("./Autosuggest.scss");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataRecord = I.Record({
  loading: false,
  suggestions: I.List([])
});

var Autosuggest = (_temp = _class = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(props) {
    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this, props));

    _this.handleChange = function (event, _ref) {
      var newValue = _ref.newValue;

      _this.setState({
        value: newValue,
        dataError: null
      });

      if (!newValue) {
        _this.props.onClear && _this.props.onClear();
      }
    };

    _this.handleClear = function () {
      _this.setState(function (_ref2) {
        var data = _ref2.data;
        return {
          data: data.merge({
            suggestions: undefined
          }),
          value: ""
        };
      });
      _this.autosuggest.input.focus();

      _this.props.onClear && _this.props.onClear();
    };

    _this.handleSuggestionsClearRequested = function () {
      _this.setState(function (_ref3) {
        var data = _ref3.data;
        return {
          data: data.merge({
            suggestions: undefined
          })
        };
      });
    };

    _this.handleSuggestionsFetchRequested = function (_ref4) {
      var newValue = _ref4.value;
      var _this$props = _this.props,
          suggestions = _this$props.suggestions,
          validateSuggestion = _this$props.validateSuggestion;
      var isSync = _this.state.isSync;


      if (isSync) {
        _this.setState(function (_ref5) {
          var data = _ref5.data;
          return {
            data: data.set("suggestions", I.List(suggestions).filter(function (suggestion) {
              return validateSuggestion(newValue, suggestion);
            }))
          };
        });
      } else {
        _this.setState(function (_ref6) {
          var data = _ref6.data;
          return {
            data: data.set("loading", true),
            dataError: null
          };
        }, function () {
          return _this.debouncedloadData(newValue);
        });
      }
    };

    _this.handleSuggestionSelected = function () {
      var _this$props2;

      (_this$props2 = _this.props).onSuggestionSelected.apply(_this$props2, arguments);
      _this.handleInputBlur();
    };

    _this.handleInputBlur = function () {
      _this.setState({ isInputFocused: false });
    };

    _this.handleInputFocus = function () {
      _this.setState({ isInputFocused: true });
    };

    _this.shouldRenderSuggestions = function (value) {
      var minQueryLength = _this.props.minQueryLength;

      return value.trim().length >= minQueryLength;
    };

    _this.renderSuggestionsContainer = function (_ref7) {
      var children = _ref7.children,
          rest = _objectWithoutProperties(_ref7, ["children"]);

      var noSuggestionsMessage = _this.props.noSuggestionsMessage;
      var _this$state = _this.state,
          data = _this$state.data,
          isInputFocused = _this$state.isInputFocused,
          value = _this$state.value;

      if (!children && !data.loading && isInputFocused && _this.shouldRenderSuggestions(value)) {
        return _react2.default.createElement(
          "div",
          rest,
          _react2.default.createElement(
            "p",
            { className: "NoSuggestionsMessage text-center erg-margin-10" },
            noSuggestionsMessage
          )
        );
      } else if (children) {
        return _react2.default.createElement(
          "div",
          rest,
          children
        );
      }

      return null;
    };

    _this.state = {
      isSync: Boolean(props.suggestions),
      data: new DataRecord(),
      dataError: null,
      value: props.value || ""
    };

    _this.debouncedloadData = (0, _lodash.debounce)(_this.loadData, props.debounceDelay);
    return _this;
  }

  _createClass(Autosuggest, [{
    key: "loadData",
    value: function loadData(value) {
      var _params,
          _this2 = this;

      var _props = this.props,
          apiHandler = _props.apiHandler,
          captureException = _props.captureException,
          dataHandler = _props.dataHandler,
          errorHandler = _props.errorHandler,
          itemHandler = _props.itemHandler,
          resultsKey = _props.resultsKey,
          url = _props.url,
          queryParam = _props.queryParam;


      apiHandler().get(url, {
        params: (_params = {}, _defineProperty(_params, queryParam, value), _defineProperty(_params, "_", Date.now()), _params)
      }).then(function (response) {
        // handle response only it is relative to curently entered query
        if (value === _this2.state.value) {
          _this2.setState(function (_ref8) {
            var data = _ref8.data;

            var suggestions = void 0;
            if (dataHandler) {
              suggestions = dataHandler(response.data);
            } else {
              var results = response.data[resultsKey] || [];
              suggestions = I.List(results).map(itemHandler);
            }

            return {
              data: data.merge({
                loading: false,
                suggestions: suggestions
              }),
              dataError: null
            };
          });
        } else {
          _this2.setState({
            dataError: null
          });
        }
      }).catch(function (err) {
        if (err.response) {
          _this2.setState({
            data: I.Map(),
            dataError: errorHandler(err.response.data)
          });
        } else if (captureException) {
          captureException(err);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$data = _state.data,
          loading = _state$data.loading,
          suggestions = _state$data.suggestions,
          dataError = _state.dataError,
          value = _state.value;
      var _props2 = this.props,
          className = _props2.className,
          getSuggestionValue = _props2.getSuggestionValue,
          placeholder = _props2.placeholder,
          errorPlaceholder = _props2.errorPlaceholder;


      var suggestionsArr = suggestions ? suggestions.toArray() : [];
      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)("erg-components-Autosuggest", className) },
        _react2.default.createElement(_reactAutosuggest2.default, {
          getSuggestionValue: getSuggestionValue,
          inputProps: {
            placeholder: dataError ? errorPlaceholder : placeholder,
            onBlur: this.handleInputBlur,
            onChange: this.handleChange,
            onFocus: this.handleInputFocus,
            value: dataError ? "" : value
          },
          onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
          onSuggestionSelected: this.handleSuggestionSelected,
          onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
          ref: function ref(autosuggest) {
            return _this3.autosuggest = autosuggest;
          },
          renderSuggestion: this.props.renderSuggestion,
          renderSuggestionsContainer: this.renderSuggestionsContainer,
          shouldRenderSuggestions: this.shouldRenderSuggestions,
          suggestions: suggestionsArr }),
        !loading && value && _react2.default.createElement("i", {
          className: "fa fa-times ClearIcon",
          onClick: this.handleClear }),
        loading && _react2.default.createElement(_LoadingIcon2.default, null)
      );
    }
  }]);

  return Autosuggest;
}(_react.Component), _class.propTypes = {
  apiHandler: _propTypes2.default.func,
  captureException: _propTypes2.default.func,
  className: _propTypes2.default.string,
  dataHandler: _propTypes2.default.func,
  debounceDelay: _propTypes2.default.number,
  errorHandler: _propTypes2.default.func,
  errorPlaceholder: _propTypes2.default.string,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  itemHandler: _propTypes2.default.func,
  minQueryLength: _propTypes2.default.number,
  noSuggestionsMessage: _propTypes2.default.string,
  onClear: _propTypes2.default.func,
  onSuggestionSelected: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  queryParam: _propTypes2.default.string.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  resultsKey: _propTypes2.default.string,
  suggestions: _propTypes2.default.array,
  url: _propTypes2.default.string,
  validateSuggestion: _propTypes2.default.func,
  value: _propTypes2.default.string
}, _class.defaultProps = {
  debounceDelay: 150,
  errorPlaceholder: "Server error on search...",
  itemHandler: function itemHandler(suggestion) {
    return suggestion;
  },
  minQueryLength: 2,
  noSuggestionsMessage: "No suggestions found.",
  placeholder: "Search...",
  resultsKey: "results",
  queryParam: "q",
  validateSuggestion: function validateSuggestion() /* value, suggestion */{
    return true;
  }
}, _temp);
exports.default = Autosuggest;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/Autosuggest.js
 ** module id = 779
 ** module chunks = 0
 **/